import moment from "moment";
import {formatCurrencyValue} from '../../util/PaymentUtils';
import {BookingTransactionTypeLabel, BookingTransactionType, DateFormats} from "../../components/constants/securspace-constants";
  import {generateSupplierInvoicesLinkFromTransaction} from "../../util/LinkUtils";

const onInvoiceClick = (payout) => {
  window.open(generateSupplierInvoicesLinkFromTransaction(payout?.transactionNumber, payout?.createdOn));
}

const onBookingClick = (payout) => {
  window.open(`/bookings/supplier-bookings?bookingNumber=${payout?.bookingNumber}`);
}

const payoutValues = Object.freeze({
  transactionNumber:  { label: 'Invoice Number',  reg: true,  ags: true,  formatter: (invoice) => invoice.transactionNumber, onClick: onInvoiceClick },
  supplierAmount:     { label: 'Amount',          reg: true,  ags: true,  formatter: (invoice) => formatCurrencyValue(invoice.supplierAmount) },
  createdOn:          { label: 'Charged Date',    reg: true,  ags: false, formatter: (invoice) => invoice.createdOn },
  serviceDates:       { label: 'Service Dates',   reg: true,  ags: false, formatter: (invoice) => invoice.serviceDates },
  paymentCreatedOn:   { label: 'Payment Date',    reg: true,  ags: false, formatter: (invoice) => invoice.paymentCreatedOn },
  agsServiceDates:    { label: 'Payment Date',    reg: false, ags: true,  formatter: (invoice) => invoice.transactionType === BookingTransactionType.AGS_FEE ? moment(invoice.serviceDates).format(DateFormats.DAY) : "—", reportLabel: 'Ags Payment Date' },
  serviceMonth:       { label: 'Service Month',   reg: false, ags: true,  formatter: (invoice) => moment(invoice.createdOn).format(DateFormats.MONTH_YEAR) },
  transactionType:    { label: 'Type',            reg: true,  ags: true,  formatter: (invoice) => BookingTransactionTypeLabel[invoice.transactionType] },
  bookingNumber:      { label: 'Booking Number',  reg: true,  ags: false, formatter: (invoice) => invoice.bookingNumber, onClick: onBookingClick },
  buyerCompanyName:   { label: 'Buyer',           reg: true,  ags: false, formatter: (invoice) => invoice.buyerCompanyName },
});

const constructHeaderCells = (filterFlag) => {
  return Object.keys(payoutValues).filter(key => payoutValues[key][filterFlag]).map(key => {
    const headerCell = {
      id: key,
      label: payoutValues[key].label
    };

    if (payoutValues[key].onClick) {
      headerCell.onClick = payoutValues[key].onClick;
    }
    return headerCell;
  });
}

export const headerCells = constructHeaderCells("reg");

export const agsHeaderCells = constructHeaderCells("ags");

export const sortByOptions = [
    {value: "none", label: "None"},
    ...headerCells.map((cell) => ({value: cell.id, label: cell.label})),
];

export const formatInvoices = (invoices) => {
  return invoices.map((invoice) => {
    const formattedInvoice = {};
    for (const invoiceItem in payoutValues) {
      formattedInvoice[invoiceItem] = payoutValues[invoiceItem].formatter(invoice);
    }
    return formattedInvoice;
  })
};

export const mapInvoicesForCsv = (invoices) => {
  if (!invoices || invoices.length === 0) {
    return invoices;
  }

  const csvData = [Object.keys(invoices[0]).map((key) => payoutValues[key].reportLabel ? payoutValues[key].reportLabel : payoutValues[key].label)];

  invoices.forEach((invoice) => csvData.push(Object.values(invoice)));

  return csvData;
};